// Global Instructions Rule Applied!
//
// Ribbon CTA pin (owner decision 2026-08-12): primary buttons that sit ON the
// brand-blue gradient ribbon keep the legacy AntD blue — the brand
// colorPrimary token (#4C90E9) would melt into the ribbon (1.0:1 contrast).
// Every custom ribbon CTA must carry this class; AddButton carries it for the
// stock one. Re-exported from ViewToolbar/index.tsx for consumers.
export const RIBBON_CTA_CLASS =
  '!bg-[#1890ff] !border-[#1890ff] hover:!bg-[#40a9ff] hover:!border-[#40a9ff]'
